<form [formGroup]="form" (ngSubmit)="onContinue()" class="form full__height">
  <article class="small__padBot">
    <div class="simulationBox">
      <div class="simulationBox__content">
        <div class="form__group">
          <div class="subtitle subtitle--row subtitle--alignLeft">
            <h2>¿Cúanto dinero necesitas?</h2>
            <div class="amountBox"><span>{{selectedPrice | currency: country.currency:'symbol':'1.0-0'}}</span></div>
          </div>

          <div class="rangeSelectionBox">
            <div class="rangeSelectionBox__item rangeSelectionBox__item--smallPad">
              <p-slider [(ngModel)]="selectedPrice" [step]="50" [min]="minPrice()" [max]="maxPrice()" (onSlideEnd)="onParameterChange($event.value)" [ngModelOptions]="{standalone: true}"></p-slider>

              <div class="rangeSelectionBox__ref">
                <span>{{minPrice() | currency: country.currency:'symbol':'1.0-0'}}</span>
                <span>{{maxPrice() | currency: country.currency:'symbol':'1.0-0'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form__group">
          <div class="subtitle subtitle--row subtitle--alignLeft">
            <h2>¿A qué plazo puedes pagarlo?</h2>
          </div>
          <div class="selectionQuota mt-15">
            <button *ngFor="let day of dayOptions" type="button"
                    (click)="onDayChange(day)" [ngClass]="selectedDay === day ? 'quota-btn selected' : 'quota-btn'">
              <div class="text"><p>{{ day / 15 }}</p> <span *ngIf="day === selectedDay">Quincenales</span></div>
            </button>
          </div>
        </div>

        <!-- SIMULATION RESULTS CARD -->
        <div class="form__group">
          <div class="simulationResumeBox__summary" *ngIf="simulationsResults() && simulationsResults().quota_from">
            <div class="simulationResumeBox__summaryCont">
              <ul class="simulationResumeBox__summaryItems">
                <li class="simulationResumeBox__summaryItem highlight"><p><span class="title">Monto Solicitado</span><span class="value">{{ selectedPrice | currency: country.currency:'symbol':'1.0-0'}}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Cuota quincenal</span><span class="value">{{ simulationsResults().quota_from | currency: country.currency:'symbol':'1.0-0'}}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Próximo pago</span><span class="value">{{ simulationsResults().first_payment_date | date: 'dd/MM/yyyy' }}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Total a pagar</span><span class="value">{{ (simulationsResults().quota_from * (selectedDay / 15)) | currency: country.currency:'symbol':'1.0-0'}}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Total cuotas</span><span class="value">{{ selectedDay / 15 }} cuotas Quincenales</span></p></li>
              </ul>
            </div>
          </div>
          <div class="refText">
            <p>* Sujeto a politicas de aprobación</p>
          </div>
        </div>
      </div>
    </div>
  </article>

  <footer>
    <div class="footer__content">
      <button pButton pRipple type="submit" [label]="simulationsResults() && simulationsResults().quota_from ? 'Continuar' : 'Simular'" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full"></button>
    </div>
  </footer>
</form>
